import { useEffect } from "react";
import { ArrowLeft, CalendarDays, Mail, Phone } from "lucide-react";
import { COMPANY } from "@/lib/policies";

export const LegalPage = ({ policy }) => {
  useEffect(() => {
    document.title = `${policy.title} | SunShell One`;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", policy.description);
    }
  }, [policy]);

  return (
    <main className="min-h-screen bg-cream px-5 pb-20 pt-28 text-navy sm:px-8">
      <div className="mx-auto max-w-4xl">
        <a
          href="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-navy/60 transition-colors hover:text-amber"
        >
          <ArrowLeft size={16} />
          Back to home
        </a>

        <header className="mt-10 border-b border-navy/10 pb-10">
          <p className="eyebrow mb-5 text-amber">Legal</p>
          <h1 className="display-serif text-5xl leading-[0.98] tracking-[-0.03em] text-navy sm:text-6xl">
            {policy.title}
          </h1>
          <p className="mt-6 max-w-3xl text-lg leading-8 text-navy/65">{policy.intro}</p>
          <div className="mt-7 flex flex-wrap gap-3 text-sm text-navy/60">
            <span className="inline-flex items-center gap-2 rounded-full border border-navy/10 bg-white px-4 py-2">
              <CalendarDays size={15} className="text-amber" />
              Last updated: {COMPANY.lastUpdated}
            </span>
            <a
              href={`mailto:${COMPANY.email}`}
              className="inline-flex items-center gap-2 rounded-full border border-navy/10 bg-white px-4 py-2 transition-colors hover:text-amber"
            >
              <Mail size={15} className="text-amber" />
              {COMPANY.email}
            </a>
            <a
              href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
              className="inline-flex items-center gap-2 rounded-full border border-navy/10 bg-white px-4 py-2 transition-colors hover:text-amber"
            >
              <Phone size={15} className="text-amber" />
              {COMPANY.phone}
            </a>
          </div>
        </header>

        <div className="mt-12 space-y-10">
          {policy.sections.map((section) => (
            <section key={section.heading} className="rounded-lg border border-navy/10 bg-white p-6 shadow-sm shadow-navy/5 sm:p-8">
              <h2 className="text-2xl font-semibold tracking-tight text-navy">{section.heading}</h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="mt-4 leading-8 text-navy/68">
                  {paragraph}
                </p>
              ))}
              {section.bullets && (
                <ul className="mt-5 space-y-3">
                  {section.bullets.map((item) => (
                    <li key={item} className="flex gap-3 leading-7 text-navy/68">
                      <span className="mt-3 h-1.5 w-1.5 shrink-0 rounded-full bg-amber" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
};
